import { action, makeObservable } from 'mobx';
import { postMessageToParent } from '../utils/general';
import { RootStore } from './root';
import { IFRMAE_EVENTS } from '../utils/constants';

export class ModalModeHandlerStore {
  private readonly rootStore: RootStore;
  private closeModalHandlers: {
    DEFAULT: () => void;
  };

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    this.closeModalHandlers = {
      DEFAULT: () => this.postCloseMessage(),
    };
    makeObservable(this, {
      onCloseModal: action.bound,
    });
  }

  public handleErrorReport(error: any) {
    if (!this.rootStore.displayStore.isFullScreenMode) {
      this.onAuthFailed(error);
    }
  }

  public onAuthCompleted(redirectUrl: string) {
    postMessageToParent({
      id: IFRMAE_EVENTS.AUTHENTICATION_COMPLETED,
      redirectUrl,
    });
  }

  public onAuthFailed(error: any) {
    postMessageToParent({ id: IFRMAE_EVENTS.AUTHENTICATION_FAILED, error });
  }

  public onCloseModal(method = 'DEFAULT') {
    this.closeModalHandlers[method]?.();
  }

  private postCloseMessage() {
    postMessageToParent({ id: 'close' });
  }
}
